import { useState } from 'react';
import { useSearchParams } from 'react-router-dom-latest';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import { useUiStoreState } from 'broker/pages/SubmissionWorkspacePage/ui-store/uiStoreProvider';
import EmailStep from './EmailStep';
import FilesStep from './FilesStep';
import { ProposalFlowStep, ProposalFlowUrlParams, UpdateProposalProps } from './types';

export default function ProposalFlowPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const stepParam = searchParams.get(ProposalFlowUrlParams.STEP) as ProposalFlowStep;

  const initialStep = Object.values(ProposalFlowStep).includes(stepParam) ? stepParam : ProposalFlowStep.Files;

  const [activeStep, setActiveStep] = useState<ProposalFlowStep>(initialStep);

  const [isDirty, setIsDirty] = useState(false);

  const { partialSubmission } = useSubmissionsWorkspace();

  const { updateSubmission } = useSubmissionsWorkspace();

  const {
    filesExplorer: { selectedFiles },
  } = useUiStoreState();

  const handleSaveProposal = async (props: UpdateProposalProps) => {
    await updateSubmission(partialSubmission!.id, {
      proposal: {
        ...props,
        lastSaved: new Date(),
      },
    });
  };

  const onStepChange = async (step: ProposalFlowStep, proposalData: UpdateProposalProps) => {
    await handleSaveProposal(proposalData);
    if (step === ProposalFlowStep.Email) {
      setIsDirty(true);
    }
    setActiveStep(step);
    setSearchParams((prevParams) => {
      const newParams = new URLSearchParams(prevParams);
      newParams.set(ProposalFlowUrlParams.STEP, step);
      return newParams;
    });
  };

  return activeStep === ProposalFlowStep.Files ? (
    <FilesStep
      selectedFiles={selectedFiles}
      submission={partialSubmission!}
      handleSaveProposal={handleSaveProposal}
      onStepChange={onStepChange}
      activeStep={activeStep}
      isDirty={isDirty}
      setIsDirty={setIsDirty}
    />
  ) : (
    <EmailStep
      selectedFiles={selectedFiles}
      submission={partialSubmission!}
      handleSaveProposal={handleSaveProposal}
      onStepChange={onStepChange}
      activeStep={activeStep}
      isDirty={isDirty}
      setIsDirty={setIsDirty}
    />
  );
}
